export default "__VITE_PUBLIC_ASSET__51107775__"